import { Pipe, PipeTransform, NgModule } from '@angular/core';

//use *ngFor='let myObj of myArr | sort:'fieldName':'asc''
@Pipe({
  name: 'arraySort'
})
export class ArraySortPipe  implements PipeTransform {
    transform(array: any[], field: string, orderby: string): any[] {
        // orderby: asc, desc
        if ( (typeof array === 'undefined') || array.length == 0)
            return [];

        if (orderby === 'asc') {
            array.sort((a: any, b: any) => {
                if (a[field] < b[field]) {
                    return -1;
                } else if (a[field] > b[field]) {
                    return 1;
                } else {
                    return 0;
                }
            });
        } else if (orderby === 'desc') {
            array.sort((a: any, b: any) => {
                if (a[field] < b[field]) {
                    return 1;
                } else if (a[field] > b[field]) {
                    return -1;
                } else {
                    return 0;
                }
            });
        }
        return array;
    }
}

@NgModule({
    declarations: [ ArraySortPipe ],
    exports: [ ArraySortPipe ],
})
export class ArraySortModule { }
